<script>
    import { store, store_offer } from '../Store.svelte';
</script>

<h1 class="text-fs-26 m-b-20">Store</h1>
<br />
<h2 class="fw-semibold">Site settings</h2>
<label>
    <input
        type="checkbox"
        bind:checked={$store.settings.advancedConfigurationMode}
    />
    Modo de compra avanzada
</label>
<br />
<p><strong>Location: </strong>{JSON.stringify($store.settings.location)}</p>
<br />
<br />

<h2 class="fw-semibold">Requested address</h2>
<p><strong>Postal code: </strong>{$store.requestedAddress.postalCode}</p>
<p><strong>Address id: </strong>{$store.requestedAddress.addressId}</p>
<p>
    <strong>Address reference: </strong>{$store.requestedAddress
        .addressReference}
</p>
<p><strong>Address string: </strong>{$store.requestedAddress.addressString}</p>

<h2 class="fw-semibold">Personal details</h2>
<p><strong>Nombre: </strong>{$store.personalDetails.nombre}</p>
<p><strong>Segundo nombre: </strong>{$store.personalDetails.segundoNombre}</p>
<p><strong>Apellido paterrno: </strong>{$store.personalDetails.apPaterno}</p>
<p><strong>Apellido mateerno: </strong>{$store.personalDetails.apMaterno}</p>
<p><strong>Correo: </strong>{$store.personalDetails.correo}</p>
<p><strong>Password: </strong>{$store.personalDetails.password}</p>
<p><strong>Celular: </strong>{$store.personalDetails.numeroCelular}</p>
<p><strong>Giro negocio: </strong>{$store.personalDetails.giroNegocio}</p>
<p><strong>Razón social: </strong>{$store.personalDetails.razonSocial}</p>

<h2 class="fw-semibold">Requested services</h2>
<p><strong>Product Id: </strong>{$store.requestedServices.productId}</p>
<p><strong>Product: </strong>{$store.requestedServices.product}</p>
<p>
    <strong>Extras canales: </strong>{JSON.stringify(
        $store.requestedServices.channelExtras
    )}
</p>
<p>
    <strong>Extras extensiones: </strong>{JSON.stringify(
        $store.requestedServices.tvExtensionsExtras
    )}
</p>
<p>
    <strong>Extras telefonia: </strong>{JSON.stringify(
        $store.requestedServices.phoneExtras
    )}
</p>
<p>
    <strong>Extras telefonía extensiones: </strong>{JSON.stringify(
        $store.requestedServices.phoneExtensionsExtras
    )}
</p>
<p>
    <strong>izzi movil plan: </strong>{JSON.stringify(
        $store.requestedServices.izzimovil.plan
    )}
</p>
<p>
    <strong>izzi movil imei: </strong>{$store.requestedServices.izzimovil.imei}
</p>
<p>
    <strong>izzi movil portability: </strong>{$store.requestedServices.izzimovil
        .portability}
</p>
<p>
    <strong>izzi movil branch: </strong>{JSON.stringify(
        $store.requestedServices.izzimovil.branch
    )}
</p>

<h2 class="fw-semibold">Purchase</h2>
<p><strong>Process Id: </strong>{$store.purchaseStatus.processId}</p>
<p><strong>Total: </strong>{$store.purchaseStatus.total}</p>
<p><strong>Finalizing: </strong>{$store.purchaseStatus.finalizing}</p>
<p><strong>Finalized: </strong>{$store.purchaseStatus.finalized}</p>
<p><strong>Finalized date: </strong>{$store.purchaseStatus.finalizedDate}</p>
<p><strong>PaymentType: </strong>{$store.purchaseStatus.paymentType}</p>
<p>
    <strong>Payment Reference: </strong>{$store.purchaseStatus.paymentReference}
</p>
<p><strong>Uploaded file: </strong>{$store.purchaseStatus.fileUploaded}</p>
<p>
    <strong>Installation date: </strong>{$store.purchaseStatus.installationDate}
</p>
<p>
    <strong>Installation time: </strong>{$store.purchaseStatus.installationTime}
</p>

<h2 class="fw-semibold">Loaded offer</h2>
<p><strong>Loaded: </strong>{$store_offer.loadedOffer.offers != null}</p>
<p><strong>Loaded date: </strong>{$store_offer.dateLoaded}</p>
<p><strong>Coverage type: </strong>{$store_offer.loadedOffer.coverageType}</p>
<p><strong>Offer: </strong>{JSON.stringify($store_offer.loadedOffer)}</p>
